import { useRef } from "react";
import { chartHours, chartRange } from "./ChartWindow";
import { useIbkrData, useVisible } from "./poller";
import { ChartParams, QuoteRow } from "./types";
import { C, ContractTitle, WidgetBox, fmt, freshnessDot } from "./ui";
import { WidgetProps } from "./windows";

// Chart card of a "chart ..." message: what the chart will show, with the live
// quote. No bars are loaded here: Open shows the live chart in its own window
// (ChartWindow.tsx), each press another one. params: ChartParams
export function ChartCardWidget({ widget, actions }: WidgetProps) {
  const ref = useRef<HTMLDivElement>(null);
  const visible = useVisible(ref);
  const p = widget.params as ChartParams;
  const { data, freshness } = useIbkrData<QuoteRow[]>("quotes", { conIds: [p.conId] }, visible);
  const row = data?.[0];
  const ok = row && "contract" in row ? row : undefined;
  const contract = ok?.contract;
  const option = contract?.secType === "OPT";
  const sep = <span style={{ color: C.muted }}> | </span>;

  return (
    <WidgetBox
      boxRef={ref}
      title={<ContractTitle contract={contract} />}
      status={row && "error" in row ? <span style={{ color: C.cancelled }}>{row.error}</span> : freshnessDot(freshness, ok?.quote.dataType)}
      onClose={actions.close}
    >
      <div style={{ padding: 10, display: "flex", flexDirection: "column", gap: 8 }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>Chart: {p.barSize} · {chartRange(p)} · {chartHours(p.outsideRth)}</span>
          <span style={{ color: C.muted }}>
            {!contract ? "…" : option
              ? `${contract.symbol} candles (${chartHours(p.outsideRth)}), option candles (regular hours) and IV per bar.`
              : "Candles with volume and the latest-price line."}
            {p.end != null ? " A fixed range (no updates)." : " Updates every 0.5s."}
          </span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 12.5, whiteSpace: "nowrap" }} title="bid | last | ask">
            {fmt(ok?.quote.bid)}{sep}<span style={{ fontWeight: 600 }}>{fmt(ok?.quote.last)}</span>{sep}{fmt(ok?.quote.ask)}
          </span>
          <button onClick={() => actions.openChart(p, `${contract?.label ?? "Chart"} · ${p.barSize}`)}
            style={{ flex: "none", height: 32, padding: "0 18px", background: C.buy, color: "#fff", border: 0, fontSize: 12.5, cursor: "pointer" }}>
            Open
          </button>
        </div>
      </div>
    </WidgetBox>
  );
}
